module.exports = __webpack_public_path__ + "fonts/IQOS-Light.ccf3db5.woff";